<template>
    <div class="progress">
        <span class="percent">{{ percent }}% </span>
        <span  :style="{width: percent + '%'}" class="stage"></span>
        <i class="fas fa-info-circle"></i>
    </div>

</template>
<script>
export default {
    props: {
        percent: {
            type: [String, Number]
        }
    }
}
</script>
<style lang="scss" scoped>
.progress {
    cursor: pointer;
    display: block;
    position: relative;
    background: rgba(#34C759, 0.2);
    border-radius: 8px;
    height: 32px;
}
.percent {
    display: block;
    position: absolute;
    font-size: 16px;
    font-weight: 400;
    color: black;
    content: "";
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
}
.stage{
    display: block;
    height: 100%;
    position: absolute;
    content: "";
    top: 50%;
    transform: translateY(-50%);
    background: #34C759;
    opacity: 0.3;
    z-index: 2;
}
i{
    cursor: pointer;
    display: block;
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    z-index: 3;
}
</style>